export default __webpack_public_path__ + "static/media/AboutBg3.75bf7eb4.png";